<span class="timer">
        <span id="minutes"> {{minutesToDday | number:'2.0' }} </span>:
        <span id="seconds"> {{secondsToDday | number:'2.0'}} </span>
</span>
